import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { PollingModule } from '@platform-frontend/platform';
import {
  ButtonModule,
  CommonWordingModule,
  CountdownModule,
  FormsModule,
  icoApple,
  icoCrossCheckDuo,
  icoFacebook,
  icoGithub,
  icoGoogle,
  icoInformationSignDuo,
  icoLinkedin,
  icoMicrosoft,
  IconsModule,
  icoXCircleDuo,
  LinkModule,
  LoadingIndicatorModule,
  TemplateVariablesModule,
  TooltipModule
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { AcceptNewTermsUiComponent } from './accept-new-terms-ui/accept-new-terms-ui.component';
import { CheckRecoveryEmailUiComponent } from './check-recovery-email-ui/check-recovery-email-ui.component';
import { DeactivatedAccountUiComponent } from './deactivated-account-ui/deactivated-account-ui.component';
import { DeclineNewTermsUiComponent } from './decline-new-terms-ui/decline-new-terms-ui.component';
import { EmailClipModule } from './email-clip';
import { ForgotPasswordFormComponent } from './forgot-password-form/forgot-password-form.component';
import { NewTermsUiComponent } from './new-terms-ui/new-terms-ui.component';
import { OAuthButtonsComponent } from './o-auth-buttons/o-auth-buttons.component';
import { OAuthProviderPipe } from './o-auth-provider.pipe';
import { OAuthUiComponent } from './o-auth-ui/o-auth-ui.component';
import { PasswordChecklistComponent } from './password-checklist/password-checklist.component';
import { ReactivateAccountUiComponent } from './reactivate-account-ui/reactivate-account-ui.component';
import { RegistrationCompleteTextComponent } from './registration-complete-text/registration-complete-text.component';
import { SignInFormComponent } from './sign-in-form/sign-in-form.component';
import { UpdatePasswordDoneTextComponent } from './update-password-done-text/update-password-done-text.component';
import { UpdatePasswordFormComponent } from './update-password-form/update-password-form.component';
import { VerifyEmailUiComponent } from './verify-email-ui/verify-email-ui.component';
import { WelcomeBackUiComponent } from './welcome-back-ui/welcome-back-ui.component';

@NgModule({
  declarations: [
    AcceptNewTermsUiComponent,
    CheckRecoveryEmailUiComponent,
    DeclineNewTermsUiComponent,
    DeactivatedAccountUiComponent,
    ForgotPasswordFormComponent,
    NewTermsUiComponent,
    OAuthButtonsComponent,
    OAuthProviderPipe,
    OAuthUiComponent,
    PasswordChecklistComponent,
    ReactivateAccountUiComponent,
    RegistrationCompleteTextComponent,
    SignInFormComponent,
    UpdatePasswordDoneTextComponent,
    UpdatePasswordFormComponent,
    VerifyEmailUiComponent,
    WelcomeBackUiComponent
  ],
  exports: [
    AcceptNewTermsUiComponent,
    CheckRecoveryEmailUiComponent,
    DeactivatedAccountUiComponent,
    DeclineNewTermsUiComponent,
    ForgotPasswordFormComponent,
    NewTermsUiComponent,
    OAuthButtonsComponent,
    OAuthProviderPipe,
    OAuthUiComponent,
    ReactivateAccountUiComponent,
    RegistrationCompleteTextComponent,
    SignInFormComponent,
    UpdatePasswordDoneTextComponent,
    UpdatePasswordFormComponent,
    VerifyEmailUiComponent,
    WelcomeBackUiComponent
  ],
  imports: [
    ButtonModule,
    CommonModule,
    CommonWordingModule,
    CountdownModule,
    EmailClipModule,
    FormsModule,
    IconsModule.withIcons(icoFacebook, icoMicrosoft, icoGithub, icoGoogle, icoLinkedin, icoApple, icoXCircleDuo, icoCrossCheckDuo, icoInformationSignDuo),
    LinkModule,
    LoadingIndicatorModule,
    MatomoTrackClickDirective,
    PollingModule,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    TemplateVariablesModule,
    TooltipModule,
    TranslocoLocaleModule,
    TranslocoMarkupModule,
    TranslocoModule
  ]
})
export class AccountUiModule {}
